import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { ProofsOfDestructionActions } from '../actions';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  current: fromModuleModels.ProofOfDestruction;
  entities: { [iri: string]: fromModuleModels.ProofOfDestruction };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  current: null,
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    ProofsOfDestructionActions.CreateProofOfDestruction,
    ProofsOfDestructionActions.ReadProofsOfDestruction,
    ProofsOfDestructionActions.ReadProofsOfDestruction,
    ProofsOfDestructionActions.UpdateProofOfDestruction,
    ProofsOfDestructionActions.DeleteProofOfDestruction,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    ProofsOfDestructionActions.CreateProofOfDestructionSuccess,
    ProofsOfDestructionActions.ReadProofOfDestructionSuccess,
    ProofsOfDestructionActions.UpdateProofOfDestructionSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        current: { ...response },
        loading: false
      };
    }
  ),
  on(
    ProofsOfDestructionActions.ReadProofsOfDestructionSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.ProofOfDestruction },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    ProofsOfDestructionActions.DeleteProofOfDestructionSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    ProofsOfDestructionActions.CreateProofOfDestructionFail,
    ProofsOfDestructionActions.ReadProofOfDestructionFail,
    ProofsOfDestructionActions.ReadProofsOfDestructionFail,
    ProofsOfDestructionActions.UpdateProofOfDestructionFail,
    ProofsOfDestructionActions.DeleteProofOfDestructionFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
